import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { ScrollToTop } from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import MenuPage from "@/pages/Menu";
import About from "@/pages/About";
import GalleryPage from "@/pages/Gallery";
import Reviews from "@/pages/Reviews";
import Visit from "@/pages/Visit";
import WestMemphis from "@/pages/WestMemphis";
import Merch from "@/pages/Merch";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/visit" element={<Visit />} />
            <Route path="/west-memphis" element={<WestMemphis />} />
            <Route path="/merch" element={<Merch />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#1A1A1A",
              border: "1px solid #333",
              color: "#fff",
              borderRadius: 0,
            },
          }}
        />
      </CartProvider>
    </div>
  );
}

export default App;
